/**
 * Shared definitions, roles, and helper functions for Tenant Customer Management
 */

export const DEFAULT_ROLE = "User";

export const TEAM_ROLES = [
  {
    id: "User",
    name: "Customer / User",
    description: "Standard customer portal access for catalog browsing, viewing pricing, and placing quote requests.",
    badgeClass: "bg-blue-50 text-[#115B9D] border-blue-200",
  },
];

export const STATUS_OPTIONS = [
  { id: "all", label: "All Customers" },
  { id: "active", label: "Active" },
  { id: "deactive", label: "Deactive" },
];

export const getRoleMeta = (roleName) => {
  const normalized = (roleName || "").toLowerCase();
  if (normalized.includes("admin")) {
    return {
      label: "Admin",
      badgeClass: "bg-purple-50 text-purple-700 border-purple-200",
    };
  }
  return {
    label: "Customer (User)",
    badgeClass: "bg-blue-50 text-[#115B9D] border-blue-200",
  };
};

export const getStatusMeta = (status) => {
  const normalized = (status || "").toLowerCase();
  const isActive = normalized === "active" || normalized === "enabled";
  return {
    isActive,
    label: isActive ? "Active" : "Deactive",
    badgeClass: isActive
      ? "bg-emerald-50 text-emerald-700 border-emerald-200"
      : "bg-rose-50 text-rose-700 border-rose-200",
    dotClass: isActive ? "bg-emerald-500" : "bg-rose-500",
  };
};

export const formatPhone = (phone) => {
  if (!phone) return "—";
  return String(phone);
};
